import { useEffect } from "react";

import log from "loglevel";
import { useLocation } from "react-router-dom";

import useAuth from "@app/common/auth/useAuth";
import { AppContextProps } from "@app/common/providers/AppContext";

import Tracker from "./Tracker";
// We only want to auto track page views for google analytics
import GaTracker from "./TrackerGoogleAnalytics";

// match location.pathname with react router

// This hook MUST be used in a child component of Router
// else useHistory will return undefined
const usePageTracking = ({ client }: { client: AppContextProps["client"] }) => {
  const { impersonating } = useAuth();
  const location = useLocation();

  useEffect(() => Tracker.setClient(client), [client]);

  useEffect(() => {
    if (impersonating) return;

    log.debug("page path: ", location.pathname, location.search);
    // do not want to track pages that start with /bot/ or /bot? to eliminate AWS firing
    if (!window.gtag) return;
    GaTracker.pageviewEvent({
      page_path: location.pathname,
    });
  }, [location.pathname, location.search]);
};

export default usePageTracking;
